import { extractReadmeDescription } from "./parseCommitData";
import { isUntouchedReadmeStub } from "./readmeStub";

// headCommit and files are required (only their values may be nullish) so a
// caller feeding branches from a query that doesn't sync the README relation is
// a compile error rather than a silent null at runtime.
type ReadmeBranch = {
  readonly name: string;
  readonly headCommit:
    | {
        readonly files: readonly {
          readonly path: string;
          readonly blob?: { readonly content: string } | null | undefined;
        }[];
      }
    | null
    | undefined;
};

export function workflowReadmeSnippet(
  branches: readonly ReadmeBranch[] | undefined
): string | null {
  const main = branches?.find((b) => b.name === "main") ?? branches?.[0];
  const readme = main?.headCommit?.files?.find((f) => f.path === "README.md");
  const blob = readme?.blob;
  if (!blob) return null;
  if (isUntouchedReadmeStub({ path: "README.md", blob })) return null;
  return extractReadmeDescription(blob.content);
}
